import { ReactNode, createContext, useState } from 'react';

/*
Notwendig um Anforderungen an die Registierung zu erfüllen. Es ist gewünscht, dass verschiedene Answer Elemente untereinander interagieren.
Würde man dies konfigurierbar machen, müsste man die Methodenaufrufe bzw. Methodennamen in die Datenbank ablegen. Dies wäre dann für andere nicht 
mehr nachvollziehbar/wartbar
*/

interface SignupProviderProps {
    children: ReactNode;
}


export type SignupContextInterface ={
    mobilnummerBestaetigt: boolean,
    setMobilnummerBestaetigt: (value: boolean) => void,

    pending: boolean,
    setPending: (value: boolean) => void,

    nummerausgewaehlt: boolean,
    setNummerausgewaehlt: (value: boolean) => void,
    
    mobilnummer:string,
    setMobilnummer: (value: string) => void,
}



const defaultContextValue: SignupContextInterface = {
    mobilnummerBestaetigt: false,
    nummerausgewaehlt: false,
    pending: false,
    setMobilnummerBestaetigt: (value: boolean) => {},
    setNummerausgewaehlt: (value: boolean) => {},
    setPending: (value: boolean) => {},
    mobilnummer: "",
    setMobilnummer: (value: string) => {},
};

export const SignupContext = createContext<SignupContextInterface>(defaultContextValue);

// Erstelle den Provider
const SignupProvider: React.FC<SignupProviderProps> = ({ children }) => {
    const [mobilnummerBestaetigt, setMobilnummerBestaetigt] = useState<boolean>(false);
    const [nummerausgewaehlt, setNummerausgewaehlt] = useState<boolean>(false);
    const [mobilnummer, setMobilnummer] = useState<string>("");
    const [pending, setPending] = useState<boolean>(false);


    const handleSetMobilnummerBestaetigt = (value: boolean) => {
        setMobilnummerBestaetigt(value);
    };

    const handleSetNummerausgewaehlt = (value: boolean) => {
        setNummerausgewaehlt(value);
    };

    const handleSetMobilnummer = (value: string) => {
        setMobilnummer(value);
    };

    const handleSetPending =  (value: boolean) => {
        setPending(value);
    };

    return (
        <SignupContext.Provider value={{ mobilnummerBestaetigt, setMobilnummerBestaetigt : handleSetMobilnummerBestaetigt,nummerausgewaehlt,setNummerausgewaehlt:handleSetNummerausgewaehlt
            ,mobilnummer,setMobilnummer:handleSetMobilnummer, pending,setPending:handleSetPending
        }}>
            {children}
        </SignupContext.Provider>
    );
};

export default SignupProvider;